<mat-card>
  <mat-card-header>
    <div class="flex justify-between" style="width: 100%;">
      <div class="text-lg self-center"> เพิ่มข้อมูลสถานที่ตรวจสอบ </div>
      <div>
        <button mat-icon-button class="close-button" (click)="endPopup('close')">
          <i class="ti ti-x text-white"></i>
        </button>
      </div>
    </div>
  </mat-card-header>
  <mat-dialog-content>
    <div class="pl-22 pr-22 flex flex-col gap-4">
      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>ชื่อสถานที่ตรวจสอบ <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input type="text" matInput [formControl]="inspectLocationSearch" placeholder="ชื่อสถานที่ตรวจสอบ"
              [matAutocomplete]="autoax2">
            <mat-autocomplete #autoax2="matAutocomplete" [displayWith]="displayInspectLocation"
              (optionSelected)="selectionInspectLocationChange($event)">
              <mat-option *ngFor="let option of filteredOptionsInspectLocation$ | async" [value]="option">
                {{option.surveyLocationName}}
              </mat-option>
            </mat-autocomplete>
            <button mat-icon-button matTooltip="ลบ" (click)="cancelItem()"
              style="width: 48px !important; margin-right: -10px" *ngIf="selectedItem">
              <i class="ti ti-backspace" style="color: #8e9db1;"></i>
            </button>
          </mat-form-field>
        </div>
      </div>

      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>เลขที่อยู่บริษัท / ถนน <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input autocomplete="off" required type="text" matInput placeholder="เลขที่อยู่บริษัท / ถนน" #input
              [(ngModel)]="form.address" name="address" #address="ngModel">
          </mat-form-field>
        </div>
      </div>

      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>แขวง / ตำบล <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input autocomplete="off" required readonly type="text" matInput placeholder="แขวง / ตำบล" #input
              [(ngModel)]="form.subDistrict" name="subDistrict" #subDistrict="ngModel" (click)="selectSubdistrict()">
          </mat-form-field>
        </div>
      </div>

      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>เขต / อำเภอ <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input autocomplete="off" required readonly type="text" matInput placeholder="เขต / อำเภอ" #input
              [(ngModel)]="form.district" name="district" #district="ngModel" (click)="selectSubdistrict()">
          </mat-form-field>
        </div>
      </div>

      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>จังหวัด <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input autocomplete="off" required readonly type="text" matInput placeholder="จังหวัด" #input
              [(ngModel)]="form.province" name="province" #province="ngModel" (click)="selectSubdistrict()">
          </mat-form-field>
        </div>
      </div>

      <div class="flex-row flex justify-between gap-2.5" style="align-items: center;">
        <div class="mat-popup-header flex flex-col">
          <h4>รหัสไปรษณีย์ <span style="color:red;">*</span></h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-form-field style="flex: 0 95%;" class="flex">
            <input autocomplete="off" required readonly type="text" matInput placeholder="รหัสไปรษณีย์" #input
              [(ngModel)]="form.postCode" name="postCode" #postCode="ngModel" (click)="selectSubdistrict()">
          </mat-form-field>
        </div>
      </div>

      <div class="flex-row flex justify-between gap-2.5">
        <div class="mat-popup-header flex flex-col">
          <h4>สถานที่ตรวจสอบหลัก</h4>
        </div>
        <div class="mat-popup flex flex-row justify-between items-center" style="width:74%">
          <div>:</div>
          <mat-slide-toggle [checked]="form.isActive === 'Y' ? true : false" (change)="onChange($event)"
            style="flex: 0 95%;" class="flex">
            เลือกเป็นสถานที่ตรวจสอบหลัก</mat-slide-toggle>
        </div>
      </div>
      <div class="flex-row flex justify-center gap-2.5" style="gap: 10px;">
        <button mat-raised-button color="accent" (click)="endPopup('save')">บันทึก</button>
        <button mat-raised-button (click)="endPopup('close')">ยกเลิก</button>
      </div>
    </div>
  </mat-dialog-content>